module.exports = __webpack_public_path__ + "img/about-us-zs-1.c33288d2.png";